import React  from "react";
import { useDispatch } from "react-redux";
import { ActionProduct } from "../../config/Redux/actionTypes";

const Search = (props) => {
  const dispatch = useDispatch();
  const handleOnChange = (e) => {
    const { value } = e.target;
    dispatch({type:ActionProduct.SEARCH, value:value})
  };
  return (
    <form className='search' onSubmit={props.search} data-aos='flip-up'>
      <input
        type={'text'}
        onChange={handleOnChange}
        value={props.value}
        placeholder='Search Name ...'
      />
      <input type='submit' value='Cari' />
    </form>
  );
}

export default Search